const INTERNAL_ERROR_MESSAGE =
  'Ocurrió un error. Proporcione el identificador de la solicitud al administrador.';

const HTTP_POLICY = {
  401: 'logout',
  403: 'forbidden',
  408: 'timeout',
  429: 'rate-limit',
  500: 'internal',
  503: 'unavailable'
};

export function mapHttpStatusPolicy(status) {
  return HTTP_POLICY[status] || 'unknown';
}

export function buildInternalErrorMessage(correlationId) {
  if (!correlationId) {
    return INTERNAL_ERROR_MESSAGE;
  }
  return `Ocurrió un error. Proporcione el ${correlationId} al administrador.`;
}

export function handleApiError(error, { onLogout, onForbidden } = {}) {
  const status = error?.status ?? 0;
  const correlationId = error?.correlationId ?? error?.data?.correlationId;
  const policy = mapHttpStatusPolicy(status);

  if (policy === 'logout' && onLogout) {
    onLogout();
    return { policy, correlationId, userMessage: 'Sesión expirada.' };
  }

  if (policy === 'forbidden' && onForbidden) {
    onForbidden();
    return { policy, correlationId, userMessage: 'No tiene permisos para esta operación.' };
  }

  if (policy === 'timeout') {
    return { policy, correlationId, userMessage: 'La operación excedió el tiempo de espera.' };
  }

  if (policy === 'internal' || policy === 'unavailable') {
    return { policy, correlationId, userMessage: buildInternalErrorMessage(correlationId) };
  }

  const functionalMessage = error?.data?.errorMessage;
  if (functionalMessage) {
    return { policy, correlationId, userMessage: functionalMessage };
  }

  return {
    policy,
    correlationId,
    userMessage: buildInternalErrorMessage(correlationId),
  };
}
